import analytics from 'analytics';
import { Page, Button, Card, Form, Input } from 'components/common';
import FormValidator from 'components/FormValidator';
import { useCallback, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Api } from 'api';

const ForgotPassword = () => {
  const [state, setState] = useState({
    email: '',
    pending: false,
    success: false
  });

  const handleChange = useCallback(
    (inputName, e) => {
      const { value } = e.target;
      setState(() => ({ ...state, [inputName]: value }));
    },
    [state]
  );

  const handleSubmit = useCallback(
    async (validate, e) => {
      e.preventDefault();
      if (!validate()) {
        return;
      }
      setState(() => ({ ...state, pending: true }));

      await Api.passwordReset(state.email)
        .then(() => {
          analytics.track('User Forgot Password', { category: 'Login' });
          setState(() => ({ ...state, pending: false, success: true }));
        })
        .catch(e => {
          setState(() => ({ ...state, pending: false }));
          throw e;
        });
    },
    [state]
  );

  const { email, pending, success } = state;

  if (success) {
    return (
      <Navigate
        to={{
          pathname: '/login',
          state: {
            withSuccess:
              'We have emailed you instructions for resetting your password'
          }
        }}
      />
    );
  }

  return (
    <Page title="Forgot password" container="sm">
      <Card
        className="fadeInAndDown"
        style={{ maxWidth: '30rem', margin: '0 auto' }}>
        <Card.Body>
          <Card.Title>
            <h1>Forgot password</h1>
            <p>
              Enter your email address below and we'll get you back on track.
            </p>
          </Card.Title>
          <FormValidator
            fields={{ email }}
            rules={{
              email: val => !val && 'Please enter your email address'
            }}>
            {(errors, validate) => (
              <Form onSubmit={e => handleSubmit(validate, e)} loading={pending}>
                <Form.Group>
                  <Input
                    name="email"
                    label="Email Address"
                    error={errors.email}
                    value={email}
                    onChange={e => handleChange('email', e)}
                    placeholder="Your email"
                    type="email"
                    autoFocus
                  />
                </Form.Group>

                <Button type="submit" color="primary" loading={pending}>
                  Request reset link
                </Button>
              </Form>
            )}
          </FormValidator>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default ForgotPassword;
